export enum OperationType {
  UpsertTaskRecord = 'upsert_task_record',
  UpsertScheduleTimeSlot = 'upsert_schedule_time_slot',
  UpsertTaskRecordCompletionDataTime = 'upsert_task_record_completion_data_time',
  UpsertDeviceStreamData = 'upsert_device_stream_data',
  UpsertGarminDeviceData = 'upsert_garmin_device_data',
  UpsertGarminDeviceDataMetadata = 'upsert_garmin_device_data_metadata',
  UpsertDeviceRawdataChunk = 'upsert_device_rawdata_chunk',
  UpsertGarminConnectDataMetadata = 'upsert_garmin_connect_data_metadata',
  UpsertGarminDailySummary = 'upsert_garmin_garmin_daily_summary',
  UpsertGarminConnectData = 'upsert_garmin_connect_data',
  UpsertDexcomData = 'upsert_dexcom_data',
  UpsertAnalyzedData = 'upsert_analyzed_data',
  RequestAnalysis = 'request_analysis',
  SetDataMigrated = 'set_data_migrated',
  SetGarminConnectDataMigrated = 'set_garmin_connect_data_migrated',
  UpsertGenericFileIndex = 'upsert_generic_file_index',
  UpsertParticipantRealtimeData = 'upsert_participant_realtime_data',
  UpsertParticipantActivityLog = 'upsert_participant_activity_log',
  UpsertMobileHeartBeat = 'upsert_mobile_heart_beat',
  UpsertParticipantJitaiEvent = 'upsert_participant_jitai_event',
}

export interface UpsertDataErrorLog {
  createdAt: Date
  operationType: OperationType
  sourceId: string[]
  result?: object
  msg?: string
  participantId?: string
}
